import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMe } from "./oidc";

/** OIDC redirect target. react-oidc-context exchanges the code automatically;
 *  once authenticated we bounce to Today. */
export function Callback() {
  const nav = useNavigate();
  const { isAuthenticated, isLoading } = useMe();
  useEffect(() => {
    if (!isLoading) nav("/today", { replace: true });
  }, [isLoading, isAuthenticated, nav]);
  return (
    <div className="grid min-h-screen place-items-center bg-canvas">
      <div className="flex items-center gap-3 text-muted">
        <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-accent" />
        Signing you in…
      </div>
    </div>
  );
}
